import { processingApi } from '@/api/processingApi'
import axios from '../axios'
import store from '../../store'

function createUrl(id) {
  const graphQlUrl = store.state.general.config.GraphQlUrl.startsWith('/')
    ? window.location.origin + store.state.general.config.GraphQlUrl
    : store.state.general.config.GraphQlUrl
  const url = new URL(`object-model/${id}`, graphQlUrl)
  return url
}

export default {
  install(Vue) {
    Vue.$objectModelRunner = Vue.prototype.$objectModelRunner = {
      async executeObjectModelQuery (id, parameters) {
        try {
          processingApi.show()
          const { data } = await axios.post(createUrl(id), parameters)
          return data
        } catch (e) {
          throw new Error(e.message)
        } finally {
          processingApi.hideAll()
        }
      }
    }
  }
}